import React from 'react';
import { useField } from 'formik';
import { Row } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const FormikTextArea = ({ label, ...props }) => {
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input>. We can use field meta to show an error
    // message if the field is invalid and it has been touched (i.e. visited)
    const [field, meta] = useField(props);
    return (
      <Row className='mx-auto'>
        <div className='d-inline-flex justify-content-center'>
          <label htmlFor={props.id || props.name}>{label}</label>
          { props.info ? 
          <div><FontAwesomeIcon className="mx-2" style={{color: "blue"}} icon={faCircleInfo} title={props.info}/></div> 
          : 
          <div></div>
          }
        </div>
        <textarea className="text-input" {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="formik-error">{meta.error}</div>
        ) : null}
      </Row>
    );
  };
  

  export default FormikTextArea